import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
            <h2>Bienvenido</h2>
        </div>
     
    );
  }
}
